// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: S0LIYKxdpKXg
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Email1 from "../../Email1"; // plasmic-import: swTRIky6t0do/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicNewResetPassword.module.css"; // plasmic-import: S0LIYKxdpKXg/css
import hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX from "./images/hxDb1FtwEoXs111Cb9TCkLalCaAvif.avif"; // plasmic-import: Xr4qffral7vX/picture

createPlasmicElementProxy;

export const PlasmicNewResetPassword__VariantProps = new Array();

export const PlasmicNewResetPassword__ArgProps = new Array();

const $$ = {};

function PlasmicNewResetPassword__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"90px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={
              hasVariant(globalVariants, "screen", "mobile") ? "150px" : "179px"
            }
            loading={"lazy"}
            src={{
              src: hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX,
              fullWidth: 512,
              fullHeight: 512,
              aspectRatio: undefined
            }}
          />

          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__sZjFe
            )}
          >
            {"Reset your password"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__rLyax
            )}
          >
            {
              "Enter the email associated with your CollectWise account and we'll send you a link to reset your password"
            }
          </div>
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames(projectcss.all, sty.freeBox)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__iZgoy
              )}
            >
              {"Email"}
            </div>
            <Email1
              data-plasmic-name={"loginEmailInput"}
              data-plasmic-override={overrides.loginEmailInput}
              className={classNames("__wab_instance", sty.loginEmailInput)}
            />

            <div
              data-plasmic-name={"invalidEmailText"}
              data-plasmic-override={overrides.invalidEmailText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.invalidEmailText
              )}
            >
              {"Invalid email address"}
            </div>
            <div
              data-plasmic-name={"emailSuccessText"}
              data-plasmic-override={overrides.emailSuccessText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.emailSuccessText
              )}
            >
              {hasVariant(globalVariants, "screen", "small")
                ? "Email has been sent"
                : hasVariant(globalVariants, "screen", "medium")
                ? "Email has been sent"
                : "Email has been sent"}
            </div>
          </div>
          <div
            data-plasmic-name={"resetPasswordButton"}
            data-plasmic-override={overrides.resetPasswordButton}
            className={classNames(projectcss.all, sty.resetPasswordButton)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__lkq2P
              )}
            >
              {"Continue"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "freeBox",
    "loginEmailInput",
    "invalidEmailText",
    "emailSuccessText",
    "resetPasswordButton"
  ],

  img: ["img"],
  freeBox: [
    "freeBox",
    "loginEmailInput",
    "invalidEmailText",
    "emailSuccessText"
  ],

  loginEmailInput: ["loginEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  emailSuccessText: ["emailSuccessText"],
  resetPasswordButton: ["resetPasswordButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewResetPassword__ArgProps,
          internalVariantPropNames: PlasmicNewResetPassword__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewResetPassword__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewResetPassword";
  } else {
    func.displayName = `PlasmicNewResetPassword.${nodeName}`;
  }
  return func;
}

export const PlasmicNewResetPassword = Object.assign(
  // Top-level PlasmicNewResetPassword renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    freeBox: makeNodeComponent("freeBox"),
    loginEmailInput: makeNodeComponent("loginEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    emailSuccessText: makeNodeComponent("emailSuccessText"),
    resetPasswordButton: makeNodeComponent("resetPasswordButton"),
    // Metadata about props expected for PlasmicNewResetPassword
    internalVariantProps: PlasmicNewResetPassword__VariantProps,
    internalArgProps: PlasmicNewResetPassword__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicNewResetPassword;
/* prettier-ignore-end */
